import hammerApi from '../api';

const profileService = hammerApi.injectEndpoints({
	endpoints: (build) => ({
		getProfile: build.query({
			query: () => ({
				url: '/administrator/me/profile',
			}),
		}),
	}),
});

export const { useGetProfileQuery } = profileService;

export default profileService;
